import React, { useEffect } from 'react';
import { Box, TextField } from 'edenred-ui';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ICreateBenefitGroupForm } from '@epi-models/pages/BenefitGroups';
import { maxLength, required } from '@epi-helpers/formHelpers/validators';
import { createRules } from '@epi-forms/helpers';
import { useOnboarding } from '@epi-shared/hooks/useOnboarding';

export const BenefitGroupName = () => {
  const { control } = useFormContext<ICreateBenefitGroupForm>();
  const { t } = useTranslation();
  const { benefitGroupNotExists } = useOnboarding();

  const validators = [required, maxLength(100)];
  const rules = createRules(validators);

  const {
    field: { ref, value, onChange },
    fieldState: { error }
  } = useController({
    name: 'groupName',
    rules,
    control
  });

  useEffect(() => {
    if (benefitGroupNotExists) {
      onChange('EmployeeGroup');
    }
  }, [benefitGroupNotExists]);

  if (benefitGroupNotExists) {
    return null;
  }

  return (
    <Box width="50%">
      <TextField
        label={t('containers.benefit_groups.group_name')}
        value={value}
        disabled={false}
        readOnly={false}
        id={`benefit-group-input-name`}
        error={!!error}
        helperText={error?.message}
        inputRef={ref}
        onChange={onChange}
      />
    </Box>
  );
};
